// Filter der Teile-Liste: reiner UI-Zustand (Suchtext + „nur sichtbare“),
// nichts davon wird gespeichert. Engine-frei.
// Gesucht wird case-insensitiv als Teilstring in Teilname UND Materialname —
// der Materialname kommt über einen Callback herein, damit diese Datei das
// Dokument nicht kennen muss.
import { isHidden } from "./visibility"

export function filterParts(parts, { query = "", onlyVisible = false } = {}, materialName = () => "") {
  const needle = String(query ?? "").trim().toLowerCase()
  return parts.filter((part) => {
    if (onlyVisible && isHidden(part)) return false
    if (needle === "") return true
    const haystack = `${part.name ?? ""} ${materialName(part) ?? ""}`.toLowerCase()
    return haystack.includes(needle)
  })
}

// Ist überhaupt gefiltert? Steuert die Trefferanzeige im Panel-Kopf
export function isFilterActive({ query = "", onlyVisible = false } = {}) {
  return String(query ?? "").trim() !== "" || onlyVisible === true
}
